import { SnackbarProgrammatic as Snackbar } from "buefy";
export default function useSnackbar() {
  const open = (message, options) => {
    // Default parameters to pass to Snackbar.
    const param = {
      message,
      actionText: "Close",
      type: "is-warning",
      indefinite: true,
      position: "is-top"
    };
    // Merge options if any is given.
    if (options) {
      Object.assign(param, options);
    }
    Snackbar.open(param);
  };

  return {
    open
  };
}
